export const GET_MODERATION_PROCESS = "testModeration/GET_MODERATION_PROCESS";
export const EVALUATE_TEST = "testModeration/EVALUATE_TEST";
export const EVALUATE_TEST_REQUEST = "testModeration/EVALUATE_TEST_REQUEST";
export const FINISH_MODERATION = "testModeration/FINISH_MODERATION";
export const FINISH_MODERATION_REQUEST = "testModeration/FINISH_MODERATION_REQUEST";
export const GO_BACK_REQUEST = "testModeration/GO_BACK_REQUEST";
export const GO_BACK = "testModeration/GO_BACK";
